import * as angular from "angular";
import {IController} from "angular";
import {Address} from "../../../addresses/models/address.model";
import {LocationType} from "../../types/location.type";
import {AccountModel} from "../../../account/angular/models/account.model";
import {DepotReferenceModel} from "../../../depots/angular/models/depot-reference.model";

export class BringozLocationDisplayComponent implements IController {

  address: Address;
  isShowLink: boolean;
  locationType: string;
  purpose: string;
  account: AccountModel;
  depot: any;
  customer: any;
  customFullName: string;

  public locationTypes: typeof LocationType = LocationType;
  public canCopyAccount: boolean = false;
  public canCopyDepot: boolean = false;
  public canCopyCustomer: boolean = false;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozLocationDisplay', {
    bindings: {
      address: '<?',
      locationType: '<',
      purpose: '<?',
      isShowLink: '<?',
      account: '<?',
      depot: '<?',
      customer: '<?',
      customFullName: '<?'
    },
    template: require('./bringoz-location-display.html').default,
    controller: BringozLocationDisplayComponent
  });
